import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UIconModule } from '@local/ui-infra';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { RestrictedConstant } from '@shared/consts';
import { AppService } from '@shared/services/app.service';
import { HubService } from 'src/app/bar/services/hub.service';

@UntilDestroy()
@Component({
  selector: 'restricted-message',
  templateUrl: './restricted-message.component.html',
  styleUrls: ['./restricted-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestrictedMessageComponent implements OnInit {
  readonly restrictedIcon: UIconModule = { type: 'font', value: 'icon-lock-fill' };
  readonly tooltipIcon: UIconModule = { type: 'font', value: 'icon-exclamation-mark-circle' };
  @Input() full: boolean = true;
  private isLauncher: boolean;
  readonly restrictedTooltip: string = RestrictedConstant.TOOLTIP;

  constructor(private hubService: HubService, private appService: AppService) {}

  ngOnInit(): void {
    this.appService.windowStyle$.pipe(untilDestroyed(this)).subscribe((b) => {
      this.isLauncher = b != 'standard';
      this.calcMode();
    });
  }

  calcMode() {
    if (this.isLauncher || ['people', 'home'].includes(this.hubService.currentLocation)) {
      this.full = false;
    }
  }

  openLearnMore(event) {
    window.open(RestrictedConstant.URL, '_blank');
    event.stopPropagation();
  }
}
